import { useEffect, useRef } from "react";
import { Box, Button, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { openModal } from "../../../../redux/actions/actions";
import PayrKycModal from "./PayrKycModal";
import PayrIframeModal from "./PayrIframeModal";

export default function PayrPayment({ payrData, onPayrUpdate }) {
  const dispatch = useDispatch();
  const autoOpenedKycRef = useRef(false);
  const autoOpenedIframeRef = useRef(null);

  const iframeUrl = payrData?.iframe_url;
  const requiresInput = !iframeUrl && !!payrData?.requires_input;

  useEffect(() => {
    if (requiresInput && !autoOpenedKycRef.current) {
      autoOpenedKycRef.current = true;
      dispatch(
        openModal(
          <PayrKycModal data={{ payrData, onPayrUpdate }} />,
          "payrKyc"
        )
      );
    }
    if (!requiresInput) {
      autoOpenedKycRef.current = false;
    }
  }, [requiresInput, payrData, onPayrUpdate, dispatch]);

  useEffect(() => {
    if (iframeUrl && autoOpenedIframeRef.current !== iframeUrl) {
      autoOpenedIframeRef.current = iframeUrl;
      dispatch(
        openModal(<PayrIframeModal data={{ iframeUrl }} />, "payrIframe")
      );
    }
    if (!iframeUrl) {
      autoOpenedIframeRef.current = null;
    }
  }, [iframeUrl, dispatch]);

  if (iframeUrl) {
    return (
      <Box sx={{ marginTop: "1.5rem" }}>
        <Typography sx={{ fontSize: "16px" }}>
          Your Payr checkout is ready. Click Pay Now to continue.
        </Typography>
      </Box>
    );
  }

  if (requiresInput) {
    return (
      <Box sx={{ marginTop: "1.5rem" }}>
        <Typography sx={{ fontSize: "16px", marginBottom: "1rem" }}>
          We need a few more details to start your Payr checkout.
        </Typography>
        <Button
          variant="contained"
          onClick={() =>
            dispatch(
              openModal(
                <PayrKycModal data={{ payrData, onPayrUpdate }} />,
                "payrKyc"
              )
            )
          }
        >
          Complete Payr details
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ marginTop: "1.5rem" }}>
      <Typography sx={{ fontSize: "16px", marginBottom: "1rem" }}>
        Pay your rent securely via Payr.
      </Typography>
      {payrData?.error ? (
        <Typography sx={{ color: "#a94442" }}>
          Payr is currently unavailable. Please try another payment method or contact support.
        </Typography>
      ) : (
        <Typography sx={{ color: "#666" }}>
          Select a student to load the Payr checkout.
        </Typography>
      )}
    </Box>
  );
}
